var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.isCreated)?_c('skin-regimen-record',{attrs:{"general":_vm.generalConfig}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }